import { render, staticRenderFns } from "./MyLearning.vue?vue&type=template&id=4c09f328"
import script from "./MyLearning.vue?vue&type=script&lang=js"
export * from "./MyLearning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports